(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('PurchaseCostReportController', PurchaseCostReportController);

	PurchaseCostReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state', '$timeout', '$location', '$anchorScroll'];

	function PurchaseCostReportController($window, WineRepository, $log, lodash, $state, $timeout, $location, $anchorScroll){

		/* jshint validthis: true */
		var self = this;

		self.winePurchasesGroupedByPriceRange = {};
		self.totalBottles = 0;
		self.totalWines = 0;
		self.groupNames = {
			'0': '$0',
			'10': '$10 and under',
			'25': '$10-24',
			'50': '$25-49',
			'75': '$50-74',
			'100': '$75-99',
			'150': '$100-149',
			'200': '$150-199',
			'500': '$200-499',
			'$500 and up': '$500 and up'
		};

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.report = {
			selectedView: 'low-high',
			loading: true,
			groups: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.title = $state.current.data.title;

		self.jumpTo = jumpTo;

		self.print = print;

		self.updateView = updateView;

		self.initialize = initialize;

		/** initialize */
		initialize();

		/** begin methods */

		function initialize() {
			self.report.availableViews = {
				'low-high': "Cost Low-High",
				'high-low': "Cost High-Low"
			};

			_resetReport();

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						self.report.tableHeaders = [
							'Wine',
							'Size',
							'Bottles In Cellar / Purchased / On Order',
							'Cost per bottle',
							'Value',
							'Gain&nbsp;/&nbsp;Loss'
						];

						// we need -1 because we are doing a > not a >= comparison, there are many 0's that will
						// only fire on -1.
						var ranges = [500, 200, 150, 100, 75, 50, 25, 10, 0, -1];

						lodash.forEach(wineEntities, function(wine) {
							if (wine.hasHistory()) {
								var purchases = wine.getPurchaseHistory();

								if (purchases.length > 0) {
									_.forEach(purchases, function(purchase) {
										var winner = '$500 and up';
										_.forEach(ranges, function(range) {
											if (purchase.price >= range) {
												// add to obj tracking prices
												if (! lodash.isArray(self.winePurchasesGroupedByPriceRange[winner])) {
													self.winePurchasesGroupedByPriceRange[winner] = [];
												}
												self.winePurchasesGroupedByPriceRange[winner].push({
													qty: purchase.qty,
													price: purchase.price,
													wine: wine
												});
												return false;
											}
											// the previous range now is the winner
											winner = range;
										});
									});
								}
							}
						});

						// totalPurchased not bottles. Is this what people what to know?
						self.totalBottles = lodash.sum(self.winePurchasesGroupedByPriceRange, function(winePurchases) {
							return lodash.sum(winePurchases, function(purchase) {
								// Bottles: in the celler + on order
								return purchase.wine.cellar.qty + purchase.qty;
							});
						});

						self.totalWines = lodash.sum(self.winePurchasesGroupedByPriceRange, function(winePurchases) {
							var wines = lodash.unique(winePurchases, function(purchase) {
								return purchase.wine._id;
							});
							return wines.length;
						});

						_updateReport();

						return true;
					}

					return false;

				}).catch(function(err){
				$log.debug('Error getting wines', err);
			});
		}

		function _updateReport() {
			var keyName = 'Price Group';
			var keyNamePlural = keyName + 's';

			// initialize totals
			var grandTotals = {
				bottlesPurchased: self.totalBottles,
				value: 0,
				groupCount: Object.keys(self.winePurchasesGroupedByPriceRange).length,
				wines:  self.totalWines
			};

			var forEachType = 'forEach';

			if (self.report.selectedView === 'high-low') {
				forEachType = 'forEachRight';
			}

			// @todo convert to an array so we can ensure order
			lodash[forEachType](self.winePurchasesGroupedByPriceRange, function(purchases, maxCost) {
				var groupTotals = {
					bottlesPurchased: 0,
					value: 0
				};

				// total value for grouping
				groupTotals.value = lodash.sum(purchases, function(purchase) {
					return purchase.qty * purchase.price;
				});

				// update grand total value
				grandTotals.value += groupTotals.value;

				var formattedWines = [];

				lodash.forEach(purchases, function(purchase) {
					var varietal = (purchase.wine.varietal && purchase.wine.varietal.name) ? purchase.wine.varietal.name + ' ' : '';
					var category = (purchase.wine.category && purchase.wine.category.name) ? purchase.wine.category.name : '';
					var type = varietal + category;

					var valueGainFormatted = purchase.wine.getRelativeGainPercentFormatted(purchase.price);
					var valueGainClass = purchase.wine.getValueGainClass(purchase.price);

					groupTotals.bottlesPurchased += purchase.qty;

					// data we want to display on a single wine
					formattedWines.push({
						name: purchase.wine.getFullName(),
						appelation: purchase.wine.getFullAppellation(),
						type: type,
						size: purchase.wine.bottleSize.name,
						qtyRemaining: purchase.wine.cellar.qty,
						qtyOnOrder: purchase.wine.getOnOrderQty(),
						qtyPurchased: purchase.qty, // the current purchase
						cost: $window.numeral(purchase.price).format('$0,0[.]00'),
						value: $window.numeral(purchase.wine.cellar.value).format('$0,0[.]00'),
						gain: valueGainFormatted,
						gainClass: valueGainClass
					});
				});

				self.report.groups.push({
					groupName: self.groupNames[maxCost],
					bottles: groupTotals.bottlesPurchased,
					value: $window.numeral(groupTotals.value).format('$0,0[.]00'),
					wines: formattedWines
				});

			});

			// @todo sort self.report.groups by .groupName
			self.report.totals = [
				// 'GroupName / Wine',
				'Total ' + keyNamePlural + ': ' + grandTotals.groupCount + '<br/>Total wines: ' + grandTotals.wines,
				// 'Size',
				null,
				// 'Bottles',
				'Total Purchased Bottles: ' + grandTotals.bottlesPurchased,
				// 'Average Cost',
				null,
				// 'Value',
				$window.numeral(grandTotals.value).format('$0,0[.]00'),
				// 'Gain / Loss'
				null
			];

			// hide loading
			self.report.loading = false;
		}

		function updateView() {
			// remove existing groupings
			self.report.groups = [];

			// show loading
			self.report.loading = true;

			// let dom update to show loading
			$timeout(function(){
				// update
				_updateReport();
			});
		}

		function _resetReport() {
			// remove existing groupings
			self.report.groups = [];
			self.winePurchasesGroupedByPriceRange = {};

			// show loading
			self.report.loading = true;

			// reset totals
			self.totalBottles = 0;
			self.totalWines = 0;
		}

		function jumpTo(id) {
			$location.hash('item-' + id);
			$anchorScroll();
		}

		function print(){
			return $window.print();
		}
	}

})();
